<template>
  <section>
    <form>
      <FormRow :fieldNameArr="[$t('PLANT_CODE'), '', $t('ACCOUNT'), '']" :col1Required="true">
        <Input v-model="plantCode" :search="true" :enter-button="$t('MORE')" @on-search="showMorePlantCodeModal" slot="a" />
        <Button v-show="canUpdate" type="success" @click="add" slot="b">{{$t('ADD')}}</Button>
        <Input v-model="targetGroupCode" slot="c" />
        <Button v-show="canUpdate" type="success" @click="copy" slot="d">{{ $t('COPY') }}</Button>
      </FormRow>
      <TablePage 
        :tableWidth="windowWidth"
        :columnsList="columnsList" 
        :resultList="plantList">
      </TablePage>
    </form>
    <Modal
      v-model="morePlantCodeModal"
      :z-index="modalSize"
      :reset-drag-position="true"
      :sticky="true"
      :draggable="true"
      :title="$t('MORE')"
      @on-ok="confirmMorePlantCodeModal"
    >
      <Input v-model="morePlantCode" type="textarea" :rows="10" />
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"

import { AlertInfo, AlertDelete } from "@/util/alert"
import { Translate } from "@/util/common"

export default {
  name: "PlantCodeMaintain",
  props: {
    plantList: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Object,
      default: () => null,
    },
  },
  components: {
  },
  data() {
    return {
      plantCode: "",
      morePlantCodeModal: false,
      morePlantCode: "",
      targetGroupCode: "",
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            let self = this
            return self.canUpdate
              ? h("Icon", {
                  props: {
                    type: "md-trash",
                    size: 28,
                  },
                  class: "text-delta-red",
                  on: {
                    click: () => {
                      self.remove(params.row)
                    },
                  },
                })
              : h("span")
          },
        },
        {
          title: this.$t('PLANT_CODE'),
          key: "plantCode",
          maxWidth: 150,
        },
        {
          title: this.$t('DESCRIPTION'),
          key: "description",
          maxWidth: 200,
        },
        {
          title: this.$t('LOCATION'),
          key: "location",
        },
        {
          title: this.$t('COMPANY_CODE'),
          key: "companyCode",
          maxWidth: 100,
        },
        {
          title: this.$t('AREA'),
          key: "area",
          maxWidth: 100,
        },
        {
          title: this.$t('COMPANY_NAME'),
          key: "companyName",
          maxWidth: 200,
        },
      ],
    }
  },
  created() {
    const vueInstance = this;
    vueInstance.$vendorHttp
      .get("/group-account/" + vueInstance.group.uuid + "/data-control/PLANT")
      .then((response) => {
        response.data._embedded.dataControlResourceList.forEach((plant) => {
          buildPlant(vueInstance, plant)
        })
      })
      .catch(() => {})
  },
  methods: {
    ...mapGetters(["getUserProfile", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    showMorePlantCodeModal() {
      this.morePlantCodeModal = true;
    },
    confirmMorePlantCodeModal() {
      const morePlantCodeArray = this.morePlantCode.split("\n").filter(morePlantCode => morePlantCode);
      this.plantCode = morePlantCodeArray.join(";");
    },
    async add() {
      const vueInstance = this;
      if (!vueInstance.plantCode) {
        return AlertInfo(vueInstance, "請選擇廠別")
          .then(() => {});
      }
      const errorMessageArray = [];
      const plantCodeArray = vueInstance.plantCode.split(";");
      const promiseArray = [];
      plantCodeArray.forEach(plantCode => {
        if (vueInstance.plantList.some(plant => plant.plantCode === plantCode)) {
          errorMessageArray.push("[" + plantCode + "] 廠別重複");
          return;
        }
        promiseArray.push(vueInstance.$authHttp
          .get("data-control/PLANT?plantCode=" + plantCode));
      });
      vueInstance.toggleLoading(true);
      const resultArray = await Promise.allSettled(promiseArray);
      resultArray.forEach(result => {
        if (result.status === "fulfilled") {
          const response = result.value;
          buildPlant(vueInstance, response.data);
          vueInstance.$linkDataControl(
            vueInstance,
            "PLANT",
            response.data.objectKey,
            vueInstance.group.code,
            "GROUP_USER"
          );
        } else {
          const error = result.reason;
          const errorMessage = vueInstance.$buildErrorMessage(error);
          errorMessageArray.push(errorMessage);
        }
      });
      if (errorMessageArray.length > 0) {
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          html: errorMessageArray.join("<br/>"),
        });
      }
      vueInstance.toggleLoading(false);
    },
    copy() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      vueInstance.$vendorHttp
        .post("group-account-maintain/copy-plant", {
          groupCode: vueInstance.group.code,
          targetGroupCode: vueInstance.targetGroupCode
        })
        .then(response => {
          vueInstance.plantList.splice(0);
          response.data.dataControlDtoList.forEach(dataControlDto => {
            buildPlant(vueInstance, dataControlDto);
          });
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    remove(item) {
      const vueInstance = this;
      AlertDelete(vueInstance, `廠別 ${item.plantCode}`)
        .then(() => {
          vueInstance.toggleLoading(true)
          vueInstance.$unlinkDataControl(
            vueInstance,
            "PLANT",
            item.plantCode,
            vueInstance.group.code,
            "GROUP_USER"
          )
          vueInstance.plantList.splice(item._index, 1)
        })
        .catch(() => {})
    }
  },
  computed: {
    canUpdate() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_PLANT_RELATION_AREA_MODIFIABLE")
      )
    },
    modalSize() {
      return this.getModalSize();
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  },
}

function buildPlant(vueInstance, plant) {
  let description = ""
  let location = ""
  let companyCode = ""
  let area = ""
  let companyName = ""
  if (plant.attributes != undefined) {
    plant.attributes.forEach((attribute) => {
      if (attribute.key == "description") {
        description = attribute.value
      }
      if (attribute.key == "location") {
        location = attribute.value
      }
      if (attribute.key == "companyCode") {
        companyCode = attribute.value
      }
      if (attribute.key == "area") {
        area = attribute.value
      }
      if (attribute.key == "companyName") {
        companyName = attribute.value
      }
    })
  }

  vueInstance.plantList.push({
    plantCode: plant.objectKey,
    description: description,
    location: location,
    companyCode: companyCode,
    area: area,
    companyName: companyName,
  })
}
</script>

<style scoped></style>
